import {Events} from "@opendaw/lib-dom"
import {TimelineRange} from "@opendaw/studio-core"

export const attachWheelScroll = (element: Element, range: TimelineRange) =>
    Events.subscribe(element, "wheel", (event: WheelEvent) => {
        const deltaX = event.deltaX
        if (deltaX !== 0) {
            event.preventDefault()
            const ratio = 0.0001
            const threshold = 1.0
            const clamped = Math.max(deltaX - threshold, 0.0) + Math.min(deltaX + threshold, 0.0)
            if (Math.abs(clamped) > 0) {range.moveBy(clamped * ratio)}
        }
    }, {passive: false})